import { App } from 'vue';
import type { SFCWithInstall } from '@/types/utils';
import Exception from './exception.vue';

Exception.install = (app: App) => {
  app.component(Exception.name, Exception);
};

export default Exception as SFCWithInstall<typeof Exception>;
